import React from "react";
import SectionHeading from "../components/SectionHeading";
import beePhoto from "../assets/frame.jpg";

export default function AboutPage() {
  return (
    <section className="pb-16 md:pb-24 flex-1 flex-col flex">
      <div>
        <img
          className="w-full h-[50vh] object-cover object-center"
          src={beePhoto}
          alt="Dandelion Bee"
        />
      </div>
      <div className="mx-auto max-w-6xl flex-1 flex-col flex">
        <div className="mt-10 bg-forest shadow-soft md:p-12 flex-1">
          <div className="text-3xl font-semibold leading-tight ">
            About Cedar & Comb
          </div>

          <div className="max-w-3xl mt-6 text-base leading-8 ">
            <div className="space-y-6 text-base leading-7">
              <div>
                <p>
                  Property hive management is a big part of what Cedar & Comb is
                  built around. Not everyone wants to become a full-time
                  beekeeper, but plenty of people like the idea of having bees
                  on their property. Some want a single hive in the garden.
                  Others have enough space for a small or even fairly large
                  apiary. Cedar & Comb is meant to make that possible in a way
                  that is straightforward and manageable.
                </p>
              </div>

              <div>
                <p>
                  That can mean helping a beginner get started with one
                  well-placed hive, or it can mean maintaining a much larger
                  setup with a dozen or more colonies on suitable land. The
                  approach depends on the property, the forage available, and
                  what the owner actually wants out of the arrangement. Some
                  people want to stay hands-off and simply host the hives.
                  Others want to learn along the way and be more involved.
                </p>
              </div>

              <div>
                <p>
                  The service is meant to be flexible. Property owners can keep
                  the honey produced on their land, and costs can be worked out
                  based on the size and needs of the setup. The overall goal is
                  to provide something that feels approachable, useful, and
                  realistic: good bee management for local properties, without
                  making it feel more complicated than it needs to be.
                </p>
              </div>

              <div>
                <p>
                  Whether the goal is one hive in a garden or a larger apiary on
                  a well-suited property, Cedar & Comb is built to offer clear,
                  practical bee management that people can actually work with.
                  The focus stays on healthy colonies, realistic arrangements,
                  and making it easier for more people to keep bees on their
                  land.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
